const ABFieldUserCore = require("../../core/dataFields/ABFieldUserCore");
module.exports = class ABFieldUser extends ABFieldUserCore {};
